// Client V1 imports
const { send: ajax } = require('client/lib/request')
// Client V2 common imports
const { FetchStateEnum } = require('client-v2/common/utils/enums')

// Action types

const SHARES_UNREAD_COUNT_FAILED = 'SHARES_UNREAD_COUNT_FAILED'
const SHARES_UNREAD_COUNT_LOADED = 'SHARES_UNREAD_COUNT_LOADED'
const SHARES_UNREAD_COUNT_LOADING = 'SHARES_UNREAD_COUNT_LOADING'
const UPDATE = 'SELF_USER_UPDATE'

// Action creators

function update(payload) {
  return {
    type: UPDATE,
    payload
  }
}

// Action dispatchers

function fetchSharesUnreadCount() {
  return async function (dispatch, getState) {
    const { user } = getState()
    if (
      // Logged-out users don't have shares
      !user.loggedIn ||
      // Bail if shares are currently being fetched
      user.sharesUnreadCountState === FetchStateEnum.LOADING
    ) {
      return
    }
    dispatch({
      type: SHARES_UNREAD_COUNT_LOADING
    })
    try {
      const payload = await ajax({
        url: '/api/v0.1/shares/unread-count',
        method: 'get'
      })
      dispatch({
        type: SHARES_UNREAD_COUNT_LOADED,
        payload
      })
    } catch (err) {
      dispatch({
        type: SHARES_UNREAD_COUNT_FAILED
      })
      throw err
    }
  }
}

module.exports = {
  // Action types
  SHARES_UNREAD_COUNT_FAILED,
  SHARES_UNREAD_COUNT_LOADED,
  SHARES_UNREAD_COUNT_LOADING,
  UPDATE,
  // Action creators
  update,
  // Action dispatchers
  fetchSharesUnreadCount
}
